import { create } from 'zustand';

export interface Invoice {
  id: number;
  invoiceNumber: string;
  projectId: number;
  projectName: string;
  clientName: string;
  amount: number;
  issueDate: string;
  dueDate: string;
  status: 'Paid' | 'Pending' | 'Overdue';
}

export interface Commission {
  id: number;
  type: 'Sales' | 'Referral' | 'Performance';
  resourceName: string;
  amount: number;
  projectName: string;
  date: string;
  status: 'Paid' | 'Pending';
}

interface FinanceStore {
  invoices: Invoice[];
  commissions: Commission[];
  createInvoice: (data: { 
    projectId: number; 
    amount: number; 
    status: 'Paid' | 'Pending' | 'Overdue'; 
    dueDate: string;
    sentDate: string;
  }) => void;
}

const mockInvoices: Invoice[] = [
  {
    id: 1,
    invoiceNumber: 'INV-2023-001',
    projectId: 1,
    projectName: 'Identity Federation Hub',
    clientName: 'TechCorp Industries',
    amount: 45000,
    issueDate: '2023-08-15',
    dueDate: '2023-09-14',
    status: 'Paid'
  },
  {
    id: 2,
    invoiceNumber: 'INV-2023-002',
    projectId: 2,
    projectName: 'Zero Trust Implementation',
    clientName: 'SecureBank Global',
    amount: 85000,
    issueDate: '2023-09-01',
    dueDate: '2023-10-15',
    status: 'Pending'
  },
  {
    id: 3,
    invoiceNumber: 'INV-2023-003',
    projectId: 3,
    projectName: 'IAM System Upgrade',
    clientName: 'Healthcare Plus',
    amount: 32000,
    issueDate: '2023-07-20',
    dueDate: '2023-08-19',
    status: 'Overdue'
  }
];

const mockCommissions: Commission[] = [
  {
    id: 1,
    type: 'Sales',
    resourceName: 'Sarah Chen',
    amount: 4500,
    projectName: 'Identity Federation Hub',
    date: '2023-08-15',
    status: 'Paid'
  },
  {
    id: 2,
    type: 'Referral',
    resourceName: 'Marcus Rodriguez',
    amount: 2000,
    projectName: 'Zero Trust Implementation',
    date: '2023-09-01',
    status: 'Pending'
  },
  {
    id: 3,
    type: 'Performance',
    resourceName: 'Emily Watson',
    amount: 3000,
    projectName: 'IAM System Upgrade',
    date: '2023-07-20',
    status: 'Paid'
  }
];

export const useFinanceStore = create<FinanceStore>((set) => ({
  invoices: mockInvoices,
  commissions: mockCommissions,
  createInvoice: (data) => set((state) => {
    const newInvoice: Invoice = {
      id: state.invoices.length + 1,
      invoiceNumber: `INV-2023-${(state.invoices.length + 1).toString().padStart(3, '0')}`,
      projectId: data.projectId,
      projectName: 'New Project', // In a real app, we'd get this from the project store
      clientName: 'Client Name', // In a real app, we'd get this from the project store
      amount: data.amount,
      issueDate: new Date().toISOString().split('T')[0],
      dueDate: data.dueDate,
      status: data.status
    };
    return { invoices: [newInvoice, ...state.invoices] };
  })
}));